import React, { useEffect, useState } from 'react'
// import { Button, Card, CardBody, CardImg, CardText, CardTitle, Spinner } from 'reactstrap';
import { domainRegex, domainRegexs, emailRegex, nameRegex, passwordRegex, numberRegex, usaNumRegex2, zipCodeRegex, usaNumRegex } from '../../../utils/Utils';
import moment from "moment-timezone";
import { Icon } from '../../../components/Component';
import Api from '../../../Api';
import Swal from 'sweetalert2';
import InputMask from 'react-input-mask';
import { cloneDeep, values } from 'lodash';
import thankYou from "../../../assets/images/onboardingThankyou.webp";
import thankYou2 from "../../../assets/images/thankyouImg_2.avif"
import axios from 'axios';
import variables from '../../../variables';
import ReCAPTCHA from 'react-google-recaptcha';
import Logo from '../../../images/logo-dark.png';
import Loaders from '../../components/loader/Loaders';
import { Card } from '@mui/material';
import { Input, Button, Spinner } from 'reactstrap';

const StepForm = () => {
    const [step, setStep] = useState(1);
    const APIV1_ROOT = variables.clientApiURL;
    const clientURL = variables.clientURL;

    const [stepData, setStepData] = useState({
        orgName: "",
        fName: "",
        lName: "",
        email: "",
        passwords: "",
        dName: "",
        terms: false,
    });
    const [loaders, setLoaders] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState({
        name: "",
        orgName: "",
        fName: "",
        lName: "",
        email: "",
        passwords: "",
        dName: "",
        terms: "",
    });
    const [passState, setPassState] = useState(false);
    const handleChanges = (eve) => {
        const { name, value } = eve?.target;
        setStepData({ ...stepData, [name]: value });
    }
    const handleSubmit = async (eve) => {
        eve.preventDefault();
        setLoaders(true);
        setDisabled(true);
        let errors = {
            orgName: nameRegex?.test(stepData?.orgName) ? "" : "Please Enter Valid Organization Name",
            fName: nameRegex?.test(stepData?.fName) ? "" : "Please Enter Valid First Name",
            lName: nameRegex?.test(stepData?.lName) ? "" : "Please Enter Valid Last Name",
            email: emailRegex?.test(stepData?.email) ? "" : "Please Enter Valid Email",
            passwords: passwordRegex?.test(stepData?.passwords) ? "" : "Use 8 or more characters with a mix of letters, numbers & symbols.",
            terms: stepData?.terms ? "" : "You need to accept terms to submit.",
            dName: error?.dName === "" ? (domainRegexs?.test(stepData?.dName) ? "" : "Please Enter Valid Domain Name") : error?.dName,
        }
        let formValidate = Object?.values(errors)?.every(ele => ele === "");
        if (formValidate) {
            setStep(2);
        }
        setError(errors);
        setDisabled(false);
        setLoaders(false);
    }
    const handleDomain = async (eve) => {
        setDisabled(true);
        setLoaders(true);
        let errors = cloneDeep(error);
        errors.dName = domainRegexs?.test(stepData?.dName) ? "" : "Please Enter Valid Domain Name";
        if (errors?.dName === "") {
            let checkBindingUrl = await Api.CheckBindingUrl(`${stepData?.dName}.ringremind.com`);
            if (checkBindingUrl?.statusCode !== 200) {
                errors.dName = "Enter Valid Domain Name"
            } else {
                errors.dName = ""
            }
        }
        setDisabled(false);
        setLoaders(false);
        setError(errors)
    }
    useEffect(() => {
        if (stepData !== null && step === 1) {
            let datas = cloneDeep(stepData);
            setStepData(datas);
        }
    }, [step])

    //form 2
    const [error2, setError2] = useState({
        streetAddress: "",
        city: "",
        State: "",
        Country: "",
        Zip: "",
        timeZone: "",
        phoneType: "",
        phoneNumber: "",
        captcha: "",
        somethinWentWrong: "",
    });
    const [timezones, setTimezones] = useState([]);
    const [isVerified, setIsVerified] = useState(false);
    const [loader2, setloaders2] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [phoneTypeList, setPhoneTypeList] = useState([{
        label: "Home",
        value: "Home",
    }]);
    const [stepForm2, setstepForm2] = useState({
        streetAddress: "",
        city: "",
        State: "",
        Country: "",
        Zip: "",
        timeZone: "",
        phoneType: phoneTypeList[0]?.value,
        phoneNumber: "",
        captcha: "",
    });
    const getCountrylistStateList = async () => {
        try {
            let list = await Api.GetOnboardAdminCountryList();
            let list2 = await Api.GetOnboardAdminState(list[0]?.countryId);
            setCountryList(list);
            setStateList(list2);
            setstepForm2({ ...stepForm2, Country: list[0]?.countryId, State: list2[0]?.stateId + " " + list2[0]?.countryId });
        } catch (error) {
            let errors = cloneDeep(error2);
            errors.somethinWentWrong = "Something Went Wrong";
            setError2(errors);
        }
    }
    useEffect(() => {
        if (step === 2) {
            const allTimezones = moment.tz.names();
            const timezonesData = allTimezones.map((timezone) => {
                const offset = moment.tz(timezone).format("Z"); // Get timezone offset in ±HH:mm format
                const gmtOffset = `(GMT${offset})`;
                const timezoneName = timezone.replace(/_/g, ' '); // Replace underscores with spaces
                return `${gmtOffset} ${timezoneName}`;
            });

            setTimezones(timezonesData);
            getCountrylistStateList();
            let errors = {
                streetAddress: "",
                city: "",
                Zip: "",
                phoneType: "",
                phoneNumber: "",
                captcha: "",
                somethinWentWrong: "",
            }
            setError2(errors);
            setloaders2(false);
        }
    }, [step]);
    const handleChanges2 = (eve) => {
        const { name, value } = eve?.target;
        setstepForm2({ ...stepForm2, [name]: value });
    }
    const ClientLogin = async (username, password, TenantId) => {
        let data = {
            "userName": username,
            "password": password,
            "tenantId": TenantId,
        }
        const config = {
            method: 'post',
            mode: 'cors',
            url: '' + `${APIV1_ROOT}` + '/api/UserLogin/ClientLogin',
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: data
        };
        let resData = {};
        await axios(config)
            .then(function (responses) {
                // console.log("axias response", JSON.stringify(responses.data));
                resData = responses.data;


            })
            .catch(function (error) {
                // console.log("error", error);
            });
        // console.log("return response", resData);
        return resData;
    }

    const AuthToken = async (username, password, TenantId) => {
        // console.log("AuthToken ", username + ' : ' + password);
        const requestdata = JSON.stringify({ UserName: username, Password: password, TenantId: TenantId });
        let responce = [];
        const config = {
            method: 'post',
            mode: 'cors',
            url: '' + `${APIV1_ROOT}` + '/Authtoken',
            headers: {
                'Content-Type': 'application/json'
            },
            data: requestdata
        };

        await axios(config)
            .then(function (response) {
                // console.log('axios get' + JSON.stringify(response.data));
                responce = response.data;
                ////console.log("responce item_key token", responce);
                // localStorage.setItem("item_key", responce.message);
                responce.data && sessionStorage.setItem("access_token", responce.data.access_token);

            })
            .catch(function (error) {
                // console.log(error);
            });
        return responce

    }
    const handleSubmit2 = async (eve) => {
        setloaders2(true);
        eve?.preventDefault();
        let errors = {
            streetAddress: stepForm2?.streetAddress ? "" : "Please Enter Valid Address",
            city: nameRegex?.test(stepForm2?.city) ? "" : "Please Enter Valid City",
            Zip: zipCodeRegex?.test(stepForm2?.Zip) ? "" : "Please Enter Zipcode",
            phoneType: "",
            phoneNumber: usaNumRegex?.test(stepForm2.phoneNumber) ? "" : "Please Enter Phone Number",
            captcha: isVerified ? "" : "Please Fill Captcha.",
            somethinWentWrong: "",
        }
        let formValidate = Object?.values(errors)?.every(ele => ele === "");
        if (formValidate) {
            setError2(errors);
            const addOnboardTenant = {
                "name": stepData?.orgName,
                "organizationName": stepData?.orgName,
                "contactName": stepData?.name,
                "firstName": stepData?.fName,
                //"middleName": "string",
                "lastName": stepData?.lName,
                "emailId": stepData?.email,
                "Password": stepData?.passwords,
                "streetAddress": stepForm2?.streetAddress,
                "city": stepForm2?.city,
                "state": stepForm2?.State,
                "zip": stepForm2?.Zip,
                "country": stepForm2?.Country,
                "timeZone": stepForm2?.timeZone ? stepForm2?.timeZone : "UTC",
                "createdBy": "admin",
                "tenantHost": [
                    {
                        "hostUrl": `${stepData?.dName}.ringremind.com`, //"brimind.panvatech.com",
                        "hostIp": "*",
                        "createdBy": "admin"
                    }
                ],
                "tenantPhone": [
                    {
                        "phoneType": stepForm2?.phoneType,
                        "phoneNo": "+1"+stepForm2?.phoneNumber,
                        "createdBy": "admin"
                    }
                ]
            }
            const InsertOnboardTenant = await Api.InsertOnboardTenant(addOnboardTenant);
            if (InsertOnboardTenant?.statusCode === 200) {
                await AuthToken(stepData?.email, stepData?.passwords, InsertOnboardTenant?.data);
                const clientlogin = await ClientLogin(stepData?.email, stepData?.passwords, InsertOnboardTenant?.data);
                if (clientlogin?.statusCode === 200) {
                    const queryParams = new URLSearchParams({
                        access_token: sessionStorage?.getItem("access_token"),
                        tName: clientlogin?.data?.name,
                        accessToken: 'token',
                        UserLoginId: clientlogin?.data?.sourceId,
                        UserLoginTypeId: clientlogin?.data?.userTypeId,
                        LoginUserName: clientlogin?.data?.userName,
                        UserLoginEmail: clientlogin?.data?.emailId,
                        LoginUserfirstName: clientlogin?.data?.firstName,
                        UserLoginlastName: clientlogin?.data?.lastName,
                        sourceId: clientlogin?.data?.sourceId,
                        counts: Date.now(),
                        tenantId: clientlogin?.data?.tenantId,
                        formDataUsername: stepData?.email,
                        formDataPassword: stepData?.passwords,
                    });
                    window.location.href = `https://${stepData?.dName}.ringremind.com/general?${queryParams?.toString()}`;
                }
                handleRecaptchaExpire()
            } else {
                errors.somethinWentWrong = "Something went wrong !";
            }
        }
        setError2(errors);
        setloaders2(false);
    }
    const handleChangeSelect = async ({ target }) => {
        const { name, value } = target;
        if (name === "Country") {
            try {
                let list2 = await Api.GetAdminState(value);
                if (list2 !== null) {
                    setStateList(list2);
                    setstepForm2({ ...stepForm2, [name]: value, State: list2[0]?.stateId + " " + list2[0]?.countryId });
                } else {
                    setStateList([]);
                }
            } catch (error) {
                Swal.fire({
                    icon: `error`,
                    title: error?.message,
                });
            }
        } else {
            setstepForm2({ ...stepForm2, [name]: value });
        }
    };

    const handleRecaptchaVerify = () => {
        setIsVerified(true);
    };

    const handleRecaptchaExpire = () => {
        setIsVerified(false);
    };

    // form 3
    const [error3, setError3] = useState({
        totalCharges: "",
        paymentNotes: "",
        payableAmount: "",
        Country: "",
        somethinWentWrong: "",
    });
    const [stepData3, setStepData3] = useState({
        totalCharges: "",
        paymentNotes: "",
        payableAmount: "",
    });
    const [loader3, setLoader3] = useState(false);
    const [value, setValue] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleChanges3 = (eve) => {
        const { name, value } = eve?.target;
        setStepData3({ ...stepData3, [name]: value });
    }

    const handleSubmit3 = async (eve) => {
        eve?.preventDefault();
        let errors = {
            totalCharges: numberRegex?.test(stepData3?.totalCharges) ? "" : "Please Enter Valid Total Charges",
            paymentNotes: stepData3?.paymentNotes ? "" : "Please Enter Valid Payment Notes",
            // payableAmount: stepData3?.payableAmount ? "" : "Please Enter Valid Payable Amount",
        }
        let formValidate = Object?.values(errors)?.every(ele => ele === "");

        if (formValidate) {
            eve?.preventDefault();
            console.log("stepData3", stepData3);

            const addOnboardTenant = {
                "name": stepData?.orgName,
                "organizationName": stepData?.orgName,
                "contactName": stepData?.name,
                "firstName": stepData?.fName,
                //"middleName": "string",
                "lastName": stepData?.lName,
                "emailId": stepData?.email,
                "Password": stepData?.passwords,
                "streetAddress": stepForm2?.streetAddress,
                "city": stepForm2?.city,
                "state": stepForm2?.State,
                "zip": stepForm2?.Zip,
                "country": stepForm2?.Country,
                "timeZone": stepForm2.timeZone ? stepForm2.timeZone : "UTC",
                "createdBy": "admin",
                "tenantHost": [
                    {
                        "hostUrl": `${stepData?.dName}.ringremind.com`, //"brimind.panvatech.com",
                        "hostIp": "*",
                        "createdBy": "admin"
                    }
                ],
                "tenantPhone": [
                    {
                        "phoneType": stepForm2.phoneType,
                        "phoneNo": "+1"+stepForm2?.phoneNumber,
                        "createdBy": "admin"
                    }
                ]
            }
            const InsertOnboardTenant = await Api.InsertOnboardTenant(addOnboardTenant);
            if (InsertOnboardTenant?.statusCode === 200) {
                await AuthToken(stepData?.email, stepData?.passwords, InsertOnboardTenant?.data);
                const clientlogin = await ClientLogin(stepData?.email, stepData?.passwords, InsertOnboardTenant?.data);
                if (clientlogin?.statusCode === 200) {
                    const queryParams = new URLSearchParams({
                        access_token: sessionStorage?.getItem("access_token"),
                        tName: clientlogin?.data?.name,
                        accessToken: 'token',
                        UserLoginId: clientlogin?.data?.sourceId,
                        UserLoginTypeId: clientlogin?.data?.userTypeId,
                        LoginUserName: clientlogin?.data?.userName,
                        UserLoginEmail: clientlogin?.data?.emailId,
                        LoginUserfirstName: clientlogin?.data?.firstName,
                        UserLoginlastName: clientlogin?.data?.lastName,
                        sourceId: clientlogin?.data?.sourceId,
                        counts: Date.now(),
                        tenantId: clientlogin?.data?.tenantId,
                        formDataUsername: stepData?.email,
                        formDataPassword: stepData?.passwords,
                    });
                    window.location.href = `https://${stepData?.dName}.ringremind.com/general?${queryParams?.toString()}`;
                    // window.open(`https://${stepData?.dName}.ringremind.com/general?${queryParams?.toString()}`, '_blank');
                }
                handleRecaptchaExpire()
            } else {
                Swal?.fire({
                    icon: "error",
                    title: "Something went wrong !",
                });
            }

        }
        setError3(errors);
    }
    const tabs = ['Card', 'ACH/EFT'];
    const tabsLogo = ['cc-alt2-fill', 'home-fill'];
    const handleTabClick = (index) => {
        setActiveIndex(index);
    };

    const checkData = (name) => {
        let checkError, checkValues, checkError2, checkValues2;
        switch (name) {
            // case "form1":
            //     checkError = Object?.values(error)?.every(ele => ele === "");
            //     checkValues = Object?.values(stepData)?.every(ele => ele !== "");
            //     return (checkError && checkValues && !loaders) ? true : false;
            case "form2":
                checkError = Object?.values(error)?.every(ele => ele === "");
                checkValues = Object?.values(stepData)?.every(ele => ele !== "");
                return (checkError && checkValues && !loaders) ? true : false;
            case "form3":
                checkError = Object?.values(error2)?.every(ele => ele === "");
                checkValues = Object?.values(stepForm2)?.every(ele => ele !== "");
                checkError2 = Object?.values(error)?.every(ele => ele === "");
                checkValues2 = Object?.values(stepData)?.every(ele => ele !== "");
                return (checkError && checkValues && !loader2 && checkError2 && checkValues2 && !loaders) ? true : false;
            default:
                return true;
        }
    }

    return (
        <>

            {/* heading */}
            <div className={`onBoard_sec ${step === 3 ? 'position-absolute start-50 top_12 translate-middle-x' : ''}`}>
                <div className='mb-2 p-3 d-flex  justify-content-center'>
                    <img src={Logo} alt='' className='object-fit-contain w-250px h-50 d-block mx-auto' />
                </div>
                <div className='d-flex  justify-content-center'>
                    <Button className={`${step >= 1 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => setStep(1)} >1</Button>
                    <Button className={`${step >= 2 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => { if (checkData("form2")) { setStep(2) } }} >2</Button>
                    {/* <Button className={`${step >= 3 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => { if (checkData("form3")) { setStep(3) } }} >3</Button> */}
                    {/* <Button className={`${step >= 1 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => setStep(1)} >1</Button>
                    <Button className={`${step >= 2 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => { { setStep(2) } }} >2</Button>
                    <Button className={`${step >= 3 ? "" : "btn-dim"} step_form_btn position-relative`} color={`primary`} tag={"h4"} onClick={eve => { { setStep(3) } }} >3</Button> */}
                </div>
            </div>
            {/* step 1 */}
            {step === 1 && <div className='position-fixed top-50 start-50 translate-middle onBoard_form_step d-block mx-auto'>
                {/* <Step1 onStep={handleStep} formDatas={form1} /> */}
                <Card className="card-bordered mt-4 w-100 step_form_card rounded">
                    <div className="card-inner">
                        <div className='text-center fs-2 fw-bold'>Basic Information</div>
                        <form onSubmit={eve => handleSubmit(eve)}>
                            <div className='d-flex flex-wrap pt-3'>
                                <div className='col-12 pb-4 position-relative'>
                                    <label className='pb-1 fw-medium'>Organization Name</label>
                                    <input className="form-control form-control-lg" type="text" name='orgName' value={stepData?.orgName} onChange={(eve) => handleChanges(eve)} maxLength={50} />
                                    {error?.orgName && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error?.orgName}</p>}
                                </div>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>First Name</label>
                                    <input className="form-control form-control-lg" type="text" name='fName' value={stepData?.fName} onChange={(eve) => handleChanges(eve)} maxLength={25} />
                                    {error?.fName && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error?.fName}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Last Name</label>
                                    <input className="form-control form-control-lg" type="text" name='lName' value={stepData?.lName} onChange={(eve) => handleChanges(eve)} maxLength={25} />
                                    {error?.lName && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0 ps-2'>{error?.lName}</p>}
                                </div>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Email</label>
                                    <input className="form-control form-control-lg" type="mail" name='email' value={stepData?.email} onChange={(eve) => handleChanges(eve)} maxLength={50} />
                                    {error?.email && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error?.email}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Password</label>
                                    <div className="form-control-wrap">
                                        <a
                                            href="#password"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                                setPassState(!passState);
                                            }}
                                            className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                                        >
                                            <Icon name="eye" className="passcode-icon icon-show"></Icon>
                                            <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                                        </a>
                                        <input
                                            className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                                            type={passState ? "text" : "password"}
                                            name='passwords'
                                            value={stepData?.passwords}
                                            onChange={(eve) => handleChanges(eve)} maxLength={16} />
                                    </div>
                                    {error?.passwords && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0 ps-2'>{error?.passwords}</p>}
                                </div>
                                <div className='col-12 pb-4 position-relative'>
                                    <label className='pb-1 fw-medium'>Domain Name</label>
                                    <div className="form-control-wrap">
                                        <div className="input-group">
                                            <input type="text" className="form-control" name='dName' value={stepData?.dName} onChange={(eve) => handleChanges(eve)} onBlur={(eve) => handleDomain(eve)} maxLength={100} />
                                            <div className="input-group-append w-300px">
                                                <span className="input-group-text w-300px p-2 fs-21px" id="basic-addon2">
                                                    .ringremind.com
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {error?.dName !== "" && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error?.dName}</p>}
                                </div>
                                <div className='col-12 pb-4 position-relative'>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            onChange={(e) => setStepData({ ...stepData, terms: !stepData.terms })}
                                            id="terms"
                                            name="terms"
                                            checked={stepData?.terms}
                                        // required
                                        />
                                        <label className="custom-control-label text-gray" htmlFor="terms">
                                            By checking this box, I give my consent that RingRemind.com may contact me with offers at the phone number above including by text, (and since we are literally a conversational AI company) autodialer or artificial voice. I also agree to the terms of service and privacy policy. Consent not required for purchase.
                                        </label>
                                    </div>
                                    {error?.terms && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error?.terms}</p>}
                                </div>
                            </div>
                            <button className="onBoardButton onBoard_btn hover_filled_slide_right ms-auto d-block" type='submit' disabled={disabled} >
                                <span className='fw-bold'>{loaders ? <Spinner size="sm" color="white" /> : "Continue"}</span>
                            </button>
                        </form>
                    </div>
                </Card>
            </div>}
            {/* step 2 */}
            {step === 2 && <div className='position-fixed top-50 start-50 translate-middle onBoard_form_step d-block mx-auto'>
                {/* <Step2 onStep={handleStep} formDatas={form1} /> */}
                <Card className="card-bordered mt-4 w-100 step_form_card rounded">
                    <div className="card-inner">
                        <div tag="h3" className='text-center fs-2 fw-bold'>Address information</div>
                        <form onSubmit={eve => handleSubmit2(eve)}>
                            <div className='d-flex flex-wrap pt-3'>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Street Address</label>
                                    <input className="form-control form-control-lg" type="text" name='streetAddress' value={stepForm2?.streetAddress} onChange={(eve) => handleChanges2(eve)} maxLength={255} />
                                    {error2?.streetAddress && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error2?.streetAddress}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>City</label>
                                    <input className="form-control form-control-lg" type="text" name='city' value={stepForm2?.city} onChange={(eve) => handleChanges2(eve)} maxLength={25} />
                                    {error2?.city && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0 ps-2'>{error2?.city}</p>}
                                </div>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>State</label>
                                    <div className='position-relative'>
                                        <select
                                            name="State"
                                            value={stepForm2?.State}
                                            onChange={(eve) => handleChangeSelect(eve)}
                                            className="form-control form-control-lg"
                                            placeholder="Select State"
                                        >
                                            {
                                                stateList?.map((ele, ind) => {
                                                    return <option label={ele?.stateName} value={ele?.stateId + " " + ele?.countryId} key={ind}></option>
                                                })
                                            }
                                        </select>
                                        <Icon name="chevron-down" className={"position-absolute top-50 end-0 pe-2 translate-middle-y"} />
                                    </div>
                                    {error2?.State && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error2?.State}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Zip</label>
                                    <InputMask
                                        onChange={(eve) => handleChanges2(eve)}
                                        value={stepForm2?.Zip}
                                        name="Zip"
                                        mask='99999'
                                        className="form-control form-control-lg "
                                        placeholder="99999"
                                    >
                                    </InputMask>
                                    {/* <input className="form-control form-control-lg" type="mail" name='Zip' value={formData?.Zip} onChange={(eve) => handleChanges(eve)} /> */}
                                    {error2?.Zip && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error2?.Zip}</p>}
                                </div>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Country</label>
                                    <div className='position-relative'>
                                        <select
                                            value={stepForm2?.Country}
                                            className="form-control form-control-lg"
                                            placeholder="Select Country"
                                            name='Country'
                                            onChange={(eve) => handleChangeSelect(eve)}
                                        >
                                            {
                                                countryList?.map((ele, ind) => {
                                                    return <option label={ele?.countryName} value={ele?.countryId} key={ind}></option>
                                                })
                                            }
                                        </select>
                                        <Icon name="chevron-down" className={"position-absolute top-50 end-0 pe-2 translate-middle-y"} />
                                    </div>
                                    {error2?.Country && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0 ps-2'>{error2?.Country}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Time Zone</label>
                                    <div className='position-relative'>
                                        <select
                                            className="form-control form-control-lg cursor-pointer "
                                            id="fv-topics"
                                            name="timeZone"
                                            value={stepForm2?.timeZone}
                                            placeholder="Select Time Zone"
                                            onChange={(eve) => handleChanges2(eve)}
                                        >
                                            {timezones.map((timezone, index) => (
                                                <option key={index} value={timezone}>{timezone}</option>
                                            ))}
                                        </select>
                                        <Icon name="chevron-down" className={"position-absolute top-50 end-0 pe-2 translate-middle-y"} />
                                    </div>
                                    {error2?.timeZone && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0 ps-2'>{error2?.timeZone}</p>}
                                </div>
                                <div className='col-6 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Phone Type</label>
                                    <div className='position-relative'>
                                        <select
                                            value={stepForm2?.phoneType}
                                            className="form-control form-control-lg"
                                            placeholder="Select Phone Type"
                                            name='phoneType'
                                            onChange={(eve) => handleChangeSelect(eve)}
                                        >
                                            {
                                                phoneTypeList?.map((ele, ind) => {
                                                    return <option label={ele?.label} value={ele?.value} key={ind}></option>
                                                })
                                            }
                                        </select>
                                        <Icon name="chevron-down" className={"position-absolute top-50 end-0 pe-2 translate-middle-y"} />
                                    </div>
                                    {/* <input className="form-control form-control-lg" type="text" name='phoneType' value={formData?.phoneType} onChange={(eve) => handleChanges(eve)} /> */}
                                    {error2?.phoneType && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error2?.phoneType}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Phone Number</label>
                                    <InputMask
                                        onChange={(eve) => handleChanges2(eve)}
                                        value={stepForm2?.phoneNumber}
                                        name="phoneNumber"
                                        mask='(999) 999-9999'
                                        className="form-control form-control-lg "
                                        placeholder="(999) 999-9999"
                                    >
                                    </InputMask>
                                    {/* <input className="form-control form-control-lg" type="text" name='phoneNumber' value={formData?.phoneType} onChange={(eve) => handleChanges(eve)} /> */}
                                    {error2?.phoneNumber && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error2?.phoneNumber}</p>}
                                </div>
                                <div className='col-6 pb-4 ps-2 position-relative'>
                                    <ReCAPTCHA
                                        sitekey="6LfSCWcpAAAAAGooP9sfax0K3txqV7MWxeOMrf6_"
                                        onChange={handleRecaptchaVerify}
                                        onExpired={handleRecaptchaExpire}
                                    />
                                    {error2?.captcha !== "" && <p className='text-danger fw-medium fs-6'>{error2?.captcha}</p>}
                                    {error2?.somethinWentWrong !== "" && <p className='text-danger fw-medium fs-6 position-absolute'>{error2?.somethinWentWrong}</p>}
                                </div>
                            </div>
                            {/* <Button color="primary" type='submit' className='ms-auto d-block fs-6 lh-sm onBoardButton rounded' >Submit</Button> */}
                            <button type='submit' className="onBoardButton onBoard_btn hover_filled_slide_right ms-auto d-block" disabled={loader2 ? true : false}>
                                <span className='fw-bold'>{loader2 ? <Spinner size="sm" color="white" /> : "Continue"}</span></button>
                        </form>
                    </div>
                </Card>
            </div>}
            {/* step 3 */}
            {/* {step === 3 && <div className='position-fixed top-50 start-50 translate-middle onBoard_form_step d-block mx-auto'>
                <Card className="card-bordered mt-4 w-50 step_form_card rounded mx-auto">
                    <div className="card-inner">
                        <h2 className='text-center fs-2 fw-bold'>Payment Method</h2>
                        <form onSubmit={eve => handleSubmit3(eve)}>
                            <div className='d-flex flex-wrap pt-3'>
                                <div className='col-12 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Payment Notes</label>
                                    <textarea className="form-control form-control-lg" 
                                    type="text" name='paymentNotes' value={stepData3?.paymentNotes} 
                                    onChange={(eve) => handleChanges3(eve)} />
                                    {error3?.paymentNotes && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error3?.paymentNotes}</p>}
                                </div>
                                <div className='col-12 pb-4 pe-2 position-relative'>
                                    <label className='pb-1 fw-medium'>Total Charges</label>
                                    <input
                                        className="form-control form-control-lg"
                                        type='number'
                                        name='totalCharges'
                                        value={stepData3?.totalCharges}
                                        onChange={(eve) => handleChanges3(eve)} maxLength={10}></input>
                                    {error3?.totalCharges && <p className='invalid pt-1 fw-medium position-absolute bottom-0 start-0'>{error3?.totalCharges}</p>}
                                </div>
                            </div>
                            <button type='submit' className="onBoardButton onBoard_btn hover_filled_slide_right ms-auto d-block"><span className='fw-bold'>{loader3 ? <Spinner size="sm" color="white" /> : "Submit"}</span></button>
                        </form>
                    </div>
                </Card>
            </div>} */}
            {/* {step === 3 && <div className='position-fixed top-50 start-50 translate-middle onBoard_form_step d-block mx-auto'><Step3 onStep={handleStep} formDatas={form1} /></div>} */}
        </>
    )
}

export default StepForm